import React, {Component, ReactElement, RefObject} from 'react'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import NatScheduleRepo from '../schedule/repository/NatScheduleRepo'
import NatEventRepo from '../event/repository/NatEventRepo'
import {PutEventSortOrderParams} from '../event/repository/NatPutEventSortOrder'
import {CurrentDateTime, NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {HolidayMasterInfo, NatGetHolidayMaster} from '../holiday/repository/NatGetHolidayMaster'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable';
import PPTextField from '../../../components/shared/forms/PPTextField';
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup';
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons';
import {SessionStorageHelper} from '../../../SessionStorageHelper';
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo';
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup';
import SearchResultCountDisplay, {
    SearchResultCountDisplayProps
} from '../../../styledComponents/adminPage/SearchResultCountDisplay';
import {Messages} from '../../../Messages';
import {
    NatGetScheduleList,
    ScheduleInfo,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from '../schedule/repository/NatGetScheduleList'
import {EventInfo, NatGetEventList, SearchCondition as EventSearchCondition} from '../event/repository/NatGetEventList'
import {SortOrder} from '../../../components/shared/SortOrder'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {
    ADMINISTORATOR_MODE,
    EVENT_CATEGORY,
    PREFECTURES_MASTER,
    VALID_OR_NOT,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea';
import AuthorityChecker from '../../../components/AuthorityChecker';
import {HKConstants} from '../../../HKConstants';
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate';
import SortableTableHeader, {
    SortableTableHeaderCell
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader';
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable';
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody';
import {SortDirection} from '@mui/material/TableCell';
import {formatDateTimeForUpdateDate, formatForDateInput} from '../../../formatters/formatDate';
import NatHolidayMasterRepo from '../holiday/repository/NatHolidayMasterRepo';
import {
    getCurrentMonth,
    getCurrentYear,
    getScheduleSettingInfo,
    getYearAfterNextDate,
    getYearDate,
    judgeAuthorityCheck,
} from '../../common/util/Natutil'
import FullCalendar, {CalendarApi, EventApi, EventInput, ViewApi} from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import '@fullcalendar/common/main.css'
import '@fullcalendar/daygrid/main.css'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {StyledTableCaption} from '../../../styledComponents/adminPage/Table'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {addEmptyData, NoSelectedValue} from '../../../componentHelper/selectHelper'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import PPSelect from '../../../components/shared/forms/PPSelect'
import {Location} from 'react-router-dom'

import {Link, Table, TableCell, TableRow} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'

const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'
const KEY_SEARCH_CONDITION: string = 'adminSchedulePageSearchCondition'
const DISP_EVENT_TITLE_LENGTH_LIMIT: number = 10
const DAILY_EVENT_DISPLAY_LIMIT: number = 3
const EVENT_LIMIT_TEXT: string = '件'
const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'


interface CalendarEvent {
    id: string
    title: string
    start: string
    order: number
    color: string
    updateDatetime: string
}

interface Props {
    condominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    holidayMasterRepo: NatHolidayMasterRepo
    scheduleRepo: NatScheduleRepo
    eventRepo: NatEventRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    currentDateTime: CurrentDateTime
    condominiumGroup: NatGetCondominiumGroup
    schedules: ScheduleInfo[]
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    searchResult: SearchResult
    currentYearMonth: string
    holidayMasterInfo: HolidayMasterInfo[]
    eventSearchCondition: EventSearchCondition
    eventList: EventInfo[]
    eventListForFullCalendar: CalendarEvent[]
    eventEditableFlg: boolean
    isLoadCompleted: boolean
    prevMonthForfullCalendar: string
    nextMonthForfullCalendar: string
    initialDisplay: boolean
    calendarStartDate: string
    calendarEndDate: string
}

interface CustumEventApi extends EventApi {
    top?: number
}

interface LastSearchCondition extends SearchCondition {
    pageNum?: number
}

class NatAdminCalendarPage extends Component<Props & AdminPagePropsSet, States> {

    calendarRef: RefObject<FullCalendar>
    mode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.mode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)


        // 前回検索条件が保持されていればデフォルト値として設定する
        let lastSearchCondition: LastSearchCondition = {}
        const sessionStorageSearchCondition: string | null = window.sessionStorage.getItem(KEY_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        } else {
            if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
                lastSearchCondition.condominiumGroupId =
                    loginUserCondominiumGroupId ? loginUserCondominiumGroupId : undefined;
                lastSearchCondition.condominiumScheduleFlag = VALID_OR_NOT_CHECK.NOT.value;
            }
        }

        let defaultSearchCondition: SearchCondition = {}
        if (Object.keys(lastSearchCondition).length) {
            defaultSearchCondition = {
                condominiumGroupId: lastSearchCondition.condominiumGroupId,
                condominiumCd: lastSearchCondition.condominiumCd,
                condominiumName: lastSearchCondition.condominiumName,
                yearsMonths: lastSearchCondition.yearsMonths,
                condominiumScheduleFlag: lastSearchCondition.condominiumScheduleFlag,
                categoryId: lastSearchCondition.categoryId,
            }
        }


        let defaultSearchConditionPage: SearchConditionPageInfo = {
            pageNum: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        if (lastSearchCondition.pageNum) {
            defaultSearchConditionPage = {
                pageNum: Number(lastSearchCondition.pageNum),
                page: COMMON_CONSTANTS.FIRST_PAGE,
            }
        }

        // 並び替え可否判定
        let eventEditableFlg: boolean = false
        // 物件モード且つ編集権限を持つユーザのみイベントの並び替え可
        if (this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value) {
            if (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_CALENDAR_MANAGEMENT)) {
                eventEditableFlg = true
            }
        }


        this.state = {
            currentDateTime: {
                currentDateTime: '',
                holidayFlag: '',
            },
            condominiumGroup: {
                details: null,
                informations: [],
                requestError: null,
                requestItemErrors: [],
            },
            schedules: [],
            searchCondition: defaultSearchCondition,
            searchConditionPageInfo: defaultSearchConditionPage,
            searchConditionSortInfo: [
                new SortOrder('updateDatetime', 'desc'),
            ],
            searchResult: {},
            currentYearMonth: '',
            holidayMasterInfo: [],
            eventSearchCondition: {},
            eventList: [],
            eventListForFullCalendar: [],
            eventEditableFlg: eventEditableFlg,
            isLoadCompleted: false,
            prevMonthForfullCalendar: '',
            nextMonthForfullCalendar: '',
            initialDisplay: true,
            calendarStartDate: '',
            calendarEndDate: '',
        }

        this.calendarRef = React.createRef()

        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.onChangeCondominiumGroupId = this.onChangeCondominiumGroupId.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onChangeCondominiumScheduleFlag = this.onChangeCondominiumScheduleFlag.bind(this)
        this.onClickRegisterScheduleButton = this.onClickRegisterScheduleButton.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeDeliveryPrefectureCd = this.onChangeDeliveryPrefectureCd.bind(this)
        this.onChangeDeliveryAddress2 = this.onChangeDeliveryAddress2.bind(this)
        this.evetDrop = this.evetDrop.bind(this)
        this.eventDragStop = this.eventDragStop.bind(this)
        this.onClickFullCalendarDate = this.onClickFullCalendarDate.bind(this)
        this.getEventSchedule = this.getEventSchedule.bind(this)
        this.handleSortSchedules = this.handleSortSchedules.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {

            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime && currentDateTime.details) {
                const currentYearMonth: string = getCurrentYear(currentDateTime.details.currentDateTime) +
                    '-' + getCurrentMonth(currentDateTime.details.currentDateTime)
                this.setState({
                    currentDateTime: currentDateTime.details,
                    currentYearMonth: currentYearMonth,
                })

            }

            // 全体モード時のみ物件グループを取得
            if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
                const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                    this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (condominiumGroupResponse && condominiumGroupResponse.details) {
                    this.setState({condominiumGroup: condominiumGroupResponse})
                }
            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    // スケジュール検索
    async searchSchedules(
        searchCondition?: SearchCondition,
        searchConditionPageInfo?: SearchConditionPageInfo,
        searchConditionSortInfo?: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const searchParams: string[] = []
            if (searchCondition) {
                if (searchCondition.condominiumGroupId) {
                    searchParams.push(`condominiumGroupId=${encodeURIComponent(searchCondition.condominiumGroupId)}`)
                }
                if (searchCondition.condominiumCd) {
                    searchParams.push(`condominiumCd=${encodeURIComponent(searchCondition.condominiumCd)}`)
                }
                if (searchCondition.condominiumName) {
                    searchParams.push(`condominiumName=${encodeURIComponent(searchCondition.condominiumName)}`)
                }
                if (searchCondition.deliveryTargetPrefectureCd) {
                    searchParams.push(`deliveryTargetPrefectureCd=${encodeURIComponent(searchCondition.deliveryTargetPrefectureCd)}`)
                }
                if (searchCondition.deliveryTargetAddress2) {
                    searchParams.push(`deliveryTargetAddress2=${encodeURIComponent(searchCondition.deliveryTargetAddress2)}`)
                }
                if (searchCondition.yearsMonths) {
                    searchParams.push(`yearsMonths=${encodeURIComponent(searchCondition.yearsMonths)}`)
                }
                if (searchCondition.condominiumScheduleFlag) {
                    searchParams.push(`condominiumScheduleFlag=${encodeURIComponent(searchCondition.condominiumScheduleFlag)}`)
                }
                if (searchCondition.categoryId) {
                    searchParams.push(`categoryId=${encodeURIComponent(searchCondition.categoryId)}`)
                }
            }
            if (searchConditionPageInfo) {
                if (searchConditionPageInfo.pageNum) {
                    searchParams.push(`pageNum=${encodeURIComponent(searchConditionPageInfo.pageNum)}`)
                }
                if (searchConditionPageInfo.page) {
                    searchParams.push(`page=${encodeURIComponent(searchConditionPageInfo.page)}`)
                }
            }

            if (searchConditionSortInfo) {
                searchConditionSortInfo.forEach((sortInfo, index) => {
                    const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
                    searchParams.push(`sortInfo=${value}`)
                })
            }

            // ソートのサブキーを追加
            const subSortKey: string = encodeURIComponent(`scheduleId:asc`)
            searchParams.push(`sortInfo=${subSortKey}`)

            // スケジュール一覧取得
            const getScheduleResponse: Nullable<NatGetScheduleList> =
                await this.props.asyncCallFunction(
                    this.props.scheduleRepo.getScheduleList.bind(
                        this.props.scheduleRepo,
                        searchParams.join('&'),
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (getScheduleResponse && getScheduleResponse.details) {
                this.setState({
                    schedules: getScheduleResponse.details.scheduleInfo,
                    searchResult: getScheduleResponse.details.searchResult,
                })
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // イベント更新
    async eventSortOrderUpdate(putEventSortOrderInfo: PutEventSortOrderParams): Promise<void> {
        const putEventSortOrderParams: PutEventSortOrderParams = {
            scheduleId: putEventSortOrderInfo.scheduleId,
            seq: putEventSortOrderInfo.seq,
            sortOrder: putEventSortOrderInfo.sortOrder,
            versionSort: putEventSortOrderInfo.versionSort,
        }
        await this.props.asyncCallFunction(
            this.props.eventRepo.putEventSortOrder.bind(this.props.eventRepo, putEventSortOrderParams),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
            },
        )
    }


    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = {
            pageNum: this.state.searchConditionPageInfo.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        await this.searchSchedules(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})

        // 検索条件を保持
        const lastSearchCondition: LastSearchCondition = {
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            deliveryTargetPrefectureCd: this.state.searchCondition.deliveryTargetPrefectureCd,
            deliveryTargetAddress2: this.state.searchCondition.deliveryTargetAddress2,
            yearsMonths: this.state.searchCondition.yearsMonths,
            condominiumScheduleFlag: this.state.searchCondition.condominiumScheduleFlag,
            categoryId: this.state.searchCondition.categoryId,
            pageNum: this.state.searchConditionPageInfo.pageNum,
        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        // イベントも再取得
        if (this.calendarRef && this.calendarRef.current) {
            const calendarApi: CalendarApi = this.calendarRef.current.getApi()
            calendarApi.refetchEvents()
        }

    }

    searchResults(): SearchResultCountDisplayProps {

        if (this.state.schedules.length === 0) {
            return {noResultMessage: Messages.IOPCC0014.toString('')}
        }

        return {
            totalCount: this.state.searchResult.total ? this.state.searchResult.total : 0,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    onChangeCondominiumGroupId(condomoniumGroupId: number): void {
        const searchCondition = this.state.searchCondition
        searchCondition.condominiumGroupId = condomoniumGroupId
        this.setState({searchCondition: searchCondition})
    }

    onChangeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumCd = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    onChangeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition = this.state.searchCondition
        searchCondition.condominiumName = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    onChangeDeliveryPrefectureCd(event: SelectChangeEvent<unknown>): void {
        const searchConditions = this.state.searchCondition
        if (event.target.value === NoSelectedValue) {
            searchConditions.deliveryTargetPrefectureCd = ''
        } else {
            const codeMaster = PREFECTURES_MASTER.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                searchConditions.deliveryTargetPrefectureCd = event.target.value as string
            } else {
                searchConditions.deliveryTargetPrefectureCd = ''
            }
        }
        this.setState({searchCondition: searchConditions})
    }

    onChangeDeliveryAddress2(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.deliveryTargetAddress2 = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            return PREFECTURES_MASTER.codeToEnumConstants(prefectureCd).label
        } else {
            return ''
        }
    }


    onChangeCondominiumScheduleFlag(): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (this.state.searchCondition.condominiumScheduleFlag === VALID_OR_NOT_CHECK.VALID.value) {
            searchCondition.condominiumScheduleFlag = VALID_OR_NOT_CHECK.NOT.value
        } else {
            searchCondition.condominiumScheduleFlag = VALID_OR_NOT_CHECK.VALID.value
        }
        this.setState({searchCondition: searchCondition})
    }

    onClickRegisterScheduleButton(): void {
        this.props.navigate('/admin/scheduleRegister')
    }

    onClickFullCalendarDate(arg: {
        date: Date;
        dateStr: string;
        allDay: boolean;
        resource?: any;
        dayEl: HTMLElement;
        jsEvent: MouseEvent;
        view: ViewApi;
    }): void {
        if (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_CALENDAR_MANAGEMENT)) {
            this.props.navigate(
                '/admin/scheduleRegister',
                {
                    state: {
                        registrationDate: arg.dateStr,
                    },
                },
            )
        }
    }

    renderScheduleTable(schedules: ScheduleInfo[]): Nullable<ReactElement> {
        if (schedules.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {id: 'title', label: 'タイトル'},
            {id: 'eventCategory', label: 'イベントカテゴリ'},
            {id: 'scheduleStartDate', label: '日程開始日'},
            {id: 'scheduleEndDate', label: '日程終了日'},
            {id: 'publishEndDate', label: '設定内容'},
        ]
        if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
            headers.push(
                {id: 'condominiumOrGroup', label: '物件グループ/物件名'},
                {id: 'deliveryTarget', label: '指定地域'},
            )
        }
        headers.push(
            {
                id: 'updateDatetime',
                label: '更新日時',
                sortable: true,
                direction: this.getSortDirection('updateDatetime'),
            })


        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.searchResult.total ? this.state.searchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                    onSortOrderChange={this.handleSortSchedules}
                />
                <SortablePaginationTableBody>
                    {this.state.schedules.map(
                        schedule => this.renderScheduleRecord(schedule),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    renderScheduleRecord(schedule: ScheduleInfo): ReactElement {
        const scheduleUrl: string = `/admin/schedule/${schedule.scheduleId}`
        return (
            <TableRow key={schedule.scheduleId}>
                <TableCellWordBreakAll align={'center'}>
                    <Link href={scheduleUrl} underline="hover">{schedule.title}</Link></TableCellWordBreakAll>
                <TableCell align={'center'}>{this.getDisplayCategoryLabel(schedule.eventCategory)}</TableCell>
                <TableCell align={'center'}>
                    {schedule.scheduleStartDate ? formatForDateInput(schedule.scheduleStartDate) : ''}
                </TableCell>
                <TableCell align={'center'}>
                    {schedule.scheduleEndDate ? formatForDateInput(schedule.scheduleEndDate) : ''}
                </TableCell>
                <TableCell align={'center'}>{
                    getScheduleSettingInfo(
                        schedule.repeatDate, schedule.repeatWeekUnit,
                        schedule.repeatWeek, schedule.repeatDayOfWeek)}
                </TableCell>
                {this.mode === ADMINISTORATOR_MODE.ALL.value && schedule.condominiumName &&
                    <TableCellWordBreakAll align={'center'}>{schedule.condominiumName}</TableCellWordBreakAll>
                }
                {this.mode === ADMINISTORATOR_MODE.ALL.value && !schedule.condominiumName &&
                    <TableCellWordBreakAll align={'center'}>{schedule.condominiumGroupName}</TableCellWordBreakAll>
                }
                {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                    <TableCellWordBreakAll align={'center'}>
                        {this.getPrefectureName(schedule.deliveryTargetPrefectureCd)}
                        {schedule.deliveryTargetAddress2}
                    </TableCellWordBreakAll>
                }
                <TableCell align={'center'}>{formatDateTimeForUpdateDate(schedule.updateDatetime)}</TableCell>
            </TableRow>
        )
    }

    getDisplayCategoryLabel(eventCategory: string): string {

        const eventCategoryMaster =
            EVENT_CATEGORY.codeToEnumConstants(eventCategory)
        if (eventCategoryMaster) {
            return eventCategoryMaster.label
        } else {
            return ''
        }
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.searchSchedules(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE

        // 検索条件を保持
        const lastSearchCondition: LastSearchCondition = {
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            deliveryTargetPrefectureCd: this.state.searchCondition.deliveryTargetPrefectureCd,
            deliveryTargetAddress2: this.state.searchCondition.deliveryTargetAddress2,
            yearsMonths: this.state.searchCondition.yearsMonths,
            condominiumScheduleFlag: this.state.searchCondition.condominiumScheduleFlag,
            categoryId: this.state.searchCondition.categoryId,
            pageNum: searchConditionPageInfo.pageNum,
        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        await this.searchSchedules(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    async handleSortSchedules(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.searchSchedules(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    evetDrop(info: any): void {
        if (info.event.start !== info.oldEvent.start) {
            info.revert()
        }
    }

    async eventDragStop(arg: { event: EventApi; el: HTMLElement; jsEvent: MouseEvent; view: ViewApi; }): Promise<void> {

        if (this.calendarRef && this.calendarRef.current) {
            const calendarApi: CalendarApi = this.calendarRef.current.getApi()

            // すべてのイベント
            const allEvents: EventApi[] = calendarApi.getEvents()

            // ドラッグ＆ドロップしたイベントと同じ日のイベント
            const dayEvents: EventApi[] = []

            // 対象日のデータのみ取得
            allEvents.forEach((eventInfo) => {
                if (eventInfo.start && arg.event && arg.event.start) {
                    if (new Date(eventInfo.start.toDateString()).getTime() ===
                        new Date(arg.event.start.toDateString()).getTime()) {
                        dayEvents.push(eventInfo)
                    }
                }

            })

            // ドラッグ＆ドロップしたイベントの座標
            const movedEventEl: ClientRect | DOMRect = arg.el.getBoundingClientRect()

            // 座標を取得する
            const tmpDayEvents: CustumEventApi[] = dayEvents

            tmpDayEvents.forEach((dayEventInfo) => {

                let tmpOrder = 0
                let top = 0
                if (arg.event.id !== dayEventInfo.id) {
                    if (arg.event._def.extendedProps.order > dayEventInfo._def.extendedProps.order) {
                        tmpOrder = arg.event._def.extendedProps.order - dayEventInfo._def.extendedProps.order
                        top = movedEventEl.top - (movedEventEl.height * tmpOrder) - tmpOrder
                    } else {
                        tmpOrder = dayEventInfo._def.extendedProps.order - arg.event._def.extendedProps.order
                        top = movedEventEl.top + (movedEventEl.height * tmpOrder) + tmpOrder
                    }
                    dayEventInfo.top = top
                } else {
                    dayEventInfo.top = arg.jsEvent.clientY
                }

            })

            // topでソートする
            tmpDayEvents.sort((a, b) => a.top && b.top ? a.top - b.top : 0)

            // 変更後の並び順にする
            const eventList = this.state.eventList

            await this.props.eventEmitter.showLoading()
            try {
                for (let i = 0; i < tmpDayEvents.length; ++i) {
                    const eventData = calendarApi.getEventById(tmpDayEvents[i].id)
                    if (eventData) {
                        await Promise.all(eventList.map(async (event) => {
                            if (String(event.scheduleId) + '_' + String(event.seq) === String(tmpDayEvents[i].id)) {
                                event.sortOrder = i + 1
                                await eventData.setExtendedProp('order', i + 1)
                                await this.eventSortOrderUpdate(event)
                            }
                        }))
                    }
                }
            } finally {
                this.setState({
                    initialDisplay: true,
                }, async () => {
                    await calendarApi.refetchEvents()
                    await this.props.eventEmitter.closeLoading()
                })
            }
        }
    }

    async getEventSchedule(info: EventInput): Promise<CalendarEvent[]> {
        const initialDisplay = this.state.initialDisplay

        if (!initialDisplay) {
            await this.props.eventEmitter.showLoading()
        }


        // 並び替えによってコールされたのか、初期表示、月変更によってコールされたかを判定
        let changeSort: boolean = false
        if (info.startStr === this.state.calendarStartDate &&
            info.endStr === this.state.calendarEndDate
        ) {
            changeSort = true
        }

        const calendarStartDate = info.startStr.slice(0, 10)
        const calendarEndDate = info.endStr.slice(0, 10)

        this.setState({
            calendarStartDate: info.startStr,
            calendarEndDate: info.endStr,
        })

        const eventListForFullCalendar: CalendarEvent[] = []

        try {

            const fullCalendarStartDate = new Date(calendarStartDate)

            if (calendarStartDate.slice(-2) !== '01') {
                // 月初でなければ翌月
                fullCalendarStartDate.setMonth(fullCalendarStartDate.getMonth() + 1, 1)
            }

            const dispCalendarStartDate: string =
                fullCalendarStartDate.getFullYear() + '-' + (fullCalendarStartDate.getMonth() + 1)

            const scheduleSearchParams: SearchCondition = this.state.searchCondition
            scheduleSearchParams.yearsMonths = dispCalendarStartDate

            // 祝日マスタ一覧取得(イベントの並び替え時はコールしない)
            if (!changeSort) {
                const holidayMasterResponse: Nullable<NatGetHolidayMaster> = await this.props.asyncCallFunction(
                    this.props.holidayMasterRepo.getHolidayMaster.bind(
                        this.props.holidayMasterRepo, calendarStartDate, calendarEndDate,
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (holidayMasterResponse && holidayMasterResponse.details) {
                    this.setState({
                        holidayMasterInfo: holidayMasterResponse.details.holidayMasterInfo,
                    })
                }
            }

            // スケジュール一覧取得(イベントの並び替え時はコールしない)
            if (!changeSort) {
                await this.searchSchedules(
                    scheduleSearchParams,
                    this.state.searchConditionPageInfo,
                    this.state.searchConditionSortInfo)

                const prevMonthForfullCalendar = new Date(calendarStartDate)
                const nextMonthForfullCalendar = new Date(calendarStartDate)

                if (calendarStartDate.slice(-2) !== '01') {
                    nextMonthForfullCalendar.setMonth(nextMonthForfullCalendar.getMonth() + 2, 1)
                } else {
                    prevMonthForfullCalendar.setMonth(prevMonthForfullCalendar.getMonth() - 1, 1)
                    nextMonthForfullCalendar.setMonth(nextMonthForfullCalendar.getMonth() + 1, 1)
                }

                this.setState({
                    prevMonthForfullCalendar: String(prevMonthForfullCalendar.getMonth() + 1),
                    nextMonthForfullCalendar: String(nextMonthForfullCalendar.getMonth() + 1),
                })
            }


            // イベント一覧取得
            const eventSearchCondition: EventSearchCondition = {}
            if (this.state.searchCondition.condominiumGroupId) {
                eventSearchCondition.condominiumGroupId = this.state.searchCondition.condominiumGroupId
            }
            if (this.state.searchCondition.condominiumCd) {
                eventSearchCondition.condominiumCd = this.state.searchCondition.condominiumCd
            }
            if (this.state.searchCondition.condominiumName) {
                eventSearchCondition.condominiumName = this.state.searchCondition.condominiumName
            }
            if (this.state.searchCondition.deliveryTargetPrefectureCd) {
                eventSearchCondition.deliveryTargetPrefectureCd = this.state.searchCondition.deliveryTargetPrefectureCd
            }
            if (this.state.searchCondition.deliveryTargetAddress2) {
                eventSearchCondition.deliveryTargetAddress2 = this.state.searchCondition.deliveryTargetAddress2
            }
            if (this.state.searchCondition.condominiumScheduleFlag) {
                eventSearchCondition.condominiumEventFlag = this.state.searchCondition.condominiumScheduleFlag
            }
            eventSearchCondition.scheduleStartDate = calendarStartDate
            eventSearchCondition.scheduleEndDate = calendarEndDate

            const getEventListResponse: Nullable<NatGetEventList> =
                await this.props.asyncCallFunction(
                    this.props.eventRepo.getEventList.bind(
                        this.props.eventRepo,
                        eventSearchCondition, undefined, undefined,
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (getEventListResponse && getEventListResponse.details) {
                this.setState({
                    eventList: getEventListResponse.details.eventInfo,
                    initialDisplay: false,
                })

                getEventListResponse.details.eventInfo.map((eventInfo, index) => {
                    if (eventInfo.invisible === VALID_OR_NOT.NOT.value) {
                        eventListForFullCalendar.push(
                            {
                                id: String(eventInfo.scheduleId) + '_' + String(eventInfo.seq),
                                title: this.processEventTitle(eventInfo.title),
                                start: eventInfo.operationDate,
                                order: eventInfo.sortOrder ? eventInfo.sortOrder : 0,
                                color: eventInfo.barColorSetting,
                                updateDatetime: eventInfo.updateDatetime,
                            },
                        )
                    }
                })
            }

            return eventListForFullCalendar

        } finally {
            if (!initialDisplay) {
                this.props.eventEmitter.closeLoading()
            }
        }
    }

    processEventTitle(title: string): string {
        if (title.length > DISP_EVENT_TITLE_LENGTH_LIMIT) {
            return title.slice(0, DISP_EVENT_TITLE_LENGTH_LIMIT - 1) + HKConstants.CMN.SYC.ELLIPSIS
        } else {
            return title
        }
    }

    renderNoSearchResult(): SearchResultCountDisplayProps {
        if (this.state.schedules.length === 0) {
            if (!Object.keys(this.state.searchCondition).length) {
                return {noResultMessage: Messages.IOPCC0015.toString('スケジュール')}
            }
            return {noResultMessage: Messages.IOPCC0014.toString('')}
        }

        return {
            totalCount: this.state.searchResult.total ? this.state.searchResult.total : 0,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>

                <ListSearchFormArea
                    onEnterKey={this.onClickSearchButton}
                >

                    {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                        <ConditionTable>
                            <ConditionTableBody>
                                <ConditionTableRow>
                                    <ConditionCategoryCell rowSpan={6}>実施範囲</ConditionCategoryCell>
                                    <ConditionColumNameCell>物件グループ</ConditionColumNameCell>
                                    <ConditionInputCell>
                                        {
                                            this.state.condominiumGroup &&
                                            this.state.condominiumGroup.details &&
                                            <>
                                                <NatCondominiumGroupSelectComponent
                                                    condominiumGroup={this.state.condominiumGroup.details}
                                                    onChangeSelectedCondominiumGroupId=
                                                        {this.onChangeCondominiumGroupId}
                                                    defaultValue={(this.state.searchCondition.condominiumGroupId) ?
                                                        this.state.searchCondition.condominiumGroupId : null}
                                                    requiredFlag={true}
                                                    eventKeys={['condominiumGroupId']}
                                                    eventEmitter={this.props.eventEmitter}
                                                    autoFocus={true}
                                                >
                                                </NatCondominiumGroupSelectComponent>
                                            </>
                                        }
                                    </ConditionInputCell>
                                    <ConditionButtonCell></ConditionButtonCell>
                                </ConditionTableRow>
                                <ConditionTableRow>
                                    <ConditionColumNameCell>物件コード</ConditionColumNameCell>
                                    <ConditionInputCell>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 6,
                                                },
                                            }}
                                            fullWidth
                                            onChange={this.onChangeCondominiumCd}
                                            defaultValue={this.state.searchCondition.condominiumCd}
                                        />
                                    </ConditionInputCell>
                                </ConditionTableRow>
                                <ConditionTableRow>
                                    <ConditionColumNameCell>物件名</ConditionColumNameCell>
                                    <ConditionInputCell>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 50,
                                                },
                                            }}
                                            fullWidth
                                            onChange={this.onChangeCondominiumName}
                                            defaultValue={this.state.searchCondition.condominiumName}
                                        />
                                    </ConditionInputCell>
                                    <ConditionButtonCell></ConditionButtonCell>
                                </ConditionTableRow>
                                <ConditionTableRow>
                                    <ConditionColumNameCell>指定地域</ConditionColumNameCell>
                                    <ConditionInputCell colSpan={2}>
                                        <LeftRowFlexContainer>
                                            <PPSelect
                                                data={
                                                    addEmptyData(PREFECTURES_MASTER.values(),
                                                        '都道府県を選択してください',
                                                    )}
                                                onChange={this.onChangeDeliveryPrefectureCd}
                                                eventKeys={['deliveryTargetPrefectureCd']}
                                                eventEmitter={this.props.eventEmitter}
                                                value={this.state.searchCondition.deliveryTargetPrefectureCd}
                                            />
                                            <ConditionColumNameCell>市区町村</ConditionColumNameCell>
                                            <PPTextField
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 50,
                                                    },
                                                }}
                                                onChange={this.onChangeDeliveryAddress2}
                                                defaultValue={this.state.searchCondition.deliveryTargetAddress2}
                                            />
                                        </LeftRowFlexContainer>
                                    </ConditionInputCell>
                                </ConditionTableRow>
                                <ConditionTableRow>
                                    <ConditionInputCell colSpan={2}>
                                        <PPCheckboxGroup
                                            data={[{
                                                label: '個別物件向けの情報を抽出する',
                                                checked:
                                                    this.state.searchCondition.condominiumScheduleFlag ===
                                                    VALID_OR_NOT_CHECK.VALID.value,
                                            }]}
                                            onChange={this.onChangeCondominiumScheduleFlag}
                                        />
                                    </ConditionInputCell>
                                    <ConditionButtonCell>
                                        <AdminDefaultMediumButton
                                            onClick={this.onClickSearchButton}>
                                            スケジュールを検索する
                                        </AdminDefaultMediumButton>
                                    </ConditionButtonCell>
                                </ConditionTableRow>
                            </ConditionTableBody>
                        </ConditionTable>
                    }
                </ListSearchFormArea>
                <SearchPageActionArea>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_CALENDAR_MANAGEMENT}>
                        <AdminDefaultMediumButton onClick={this.onClickRegisterScheduleButton}>
                            新規
                        </AdminDefaultMediumButton>
                    </AuthorityChecker>
                </SearchPageActionArea>
                <MarginTable>
                    <Table>
                        <StyledTableCaption>月間スケジュール</StyledTableCaption>
                    </Table>
                </MarginTable>
                <FullCalendarCss
                    publicHoliday={this.state.holidayMasterInfo}
                    prevMonthForfullCalendar={this.state.prevMonthForfullCalendar}
                    nextMonthForfullCalendar={this.state.nextMonthForfullCalendar}
                >
                    <FullCalendar
                        headerToolbar={
                            {
                                left: '',
                                center: 'prev title next',
                                right: '',
                            }
                        }
                        buttonText={
                            {
                                prev: '月',
                                next: '月',
                            }
                        }
                        validRange={
                            {
                                start: getYearDate(),
                                end: formatForDateInput(
                                    getYearAfterNextDate(this.state.currentDateTime.currentDateTime)),
                            }
                        }
                        ref={this.calendarRef}
                        initialDate={formatForDateInput(this.state.currentDateTime.currentDateTime)}
                        initialView="dayGridMonth" plugins={[dayGridPlugin, interactionPlugin]}
                        events={this.getEventSchedule}
                        locale={'ja'}
                        eventOrder={'order,-updateDatetime'}
                        editable={this.state.eventEditableFlg}
                        eventDrop={this.evetDrop}
                        eventDragStop={this.eventDragStop}
                        eventDurationEditable={true}
                        dateClick={this.onClickFullCalendarDate}
                        dayMaxEventRows={DAILY_EVENT_DISPLAY_LIMIT}
                        moreLinkText={EVENT_LIMIT_TEXT}
                        moreLinkHint={''}

                    />
                </FullCalendarCss>
                <MarginTable>
                    <Table>
                        <StyledTableCaption>スケジュール一覧</StyledTableCaption>
                    </Table>
                </MarginTable>
                <PageMainArea>
                    {this.renderScheduleTable(this.state.schedules)}
                </PageMainArea>


                <SearchResultCountDisplay
                    {...this.renderNoSearchResult()}
                />
            </>
        )
    }

}


interface PublicHolidayList {
    publicHoliday: HolidayMasterInfo[];
    prevMonthForfullCalendar: string;
    nextMonthForfullCalendar: string;
}

const getPublicHolidayCss = (props: PublicHolidayList) => {
    let styles = ''
    props.publicHoliday.map((publicHolidayInfo) => {
        styles += `
        & .fc-daygrid-day[data-date="${publicHolidayInfo.holidayYearsMonthsDate}"] {color: red;}
    `
    })
    styles += `
        & button.fc-prev-button:before {
            content: '${'< ' + props.prevMonthForfullCalendar}';
        }
    `
    styles += `
        & button.fc-next-button:before {
            content: '${props.nextMonthForfullCalendar}';
        }
        & button.fc-next-button:after {
            content: ' >';
        }
    `

    return styles
}

export const MarginTable: StyledDiv = styled.div`
  margin: 10px 0 10px 0;
`

export const FullCalendarCss = styled.div<PublicHolidayList>`
  & .fc-day-sun {
    color: red;
  }

  & .fc-day-sat {
    color: blue;
  }

  ${(props: PublicHolidayList) => getPublicHolidayCss(props)}
  & .fc-toolbar-chunk {
    display: inline-flex;
  }

  & button.fc-prev-button, button.fc-next-button {
    color: #3f51b5;
    background-color: transparent;
    border-color: transparent;
  }

  & .fc-button-primary:focus {
    box-shadow: initial;
  }
`

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`

export default createAdminPage(NatAdminCalendarPage)
